import {
  type GetLocalServiceProvidersResponse,
  LSPTypes,
} from '@omnipresentgroup/types';

export const GET_LSPS_RESPONSE: GetLocalServiceProvidersResponse = [
  {
    id: 'LSP-21-001',
    name: 'Emerald inc.',
    countries: ['Brazil', 'United Kingdom'],
    type: LSPTypes.EMPLOYER_OF_RECORD,
    profileUrl: 'htt://test',
    noOfEmployees: 0,
    contactEmails: ['foo@bar.com'],
  },
  {
    id: 'PP-21-001',
    name: 'Emerald Payroll inc.',
    countries: [
      'Australia',
      'Cambodia',
      'China',
      'Denmark',
      'Hong Kong',
      'India',
      'Indonesia',
      'Japan',
      'Malaysia',
      'Mongolia',
      'New Zealand',
      'Singapore',
      'Taiwan',
      'Thailand',
      'Vietnam',
    ],
    type: LSPTypes.PAYROLL_PROVIDER,
    noOfEmployees: 10,
    inactive: true,
  },
  {
    id: 'LSP-0012',
    name: 'Parakar',
    type: LSPTypes.EMPLOYER_OF_RECORD,
    noOfEmployees: 11,
  },
  {
    id: 'LSP-0013',
    name: 'Employ Global',
    type: LSPTypes.EMPLOYER_OF_RECORD,
    noOfEmployees: 12,
  },
  {
    id: 'LSP-0014',
    name: 'Hire Global',
    type: LSPTypes.EMPLOYER_OF_RECORD,
    noOfEmployees: 13,
  },
  {
    id: 'LSP-0015',
    name: 'OP',
    type: LSPTypes.EMPLOYER_OF_RECORD,
    noOfEmployees: 14,
    inactive: true,
  },
  {
    id: 'of1WbA9Hc2OP',
    name: 'Mock Pay',
    type: LSPTypes.PAYROLL_PROVIDER,
    noOfEmployees: 1,
  },
];
